// Stažení souboru, který systém neumí otevřít. Při dvojkliku se nejdřív zeptáme (předvolba `downloadConfirm`,
// výchozí zapnuto) – ať si uživatel nestáhne několik souborů omylem; výslovný příkaz Stáhnout se neptá.
import { confirm } from '../components/dialog';
import { t } from '../i18n';

export async function downloadItem(item: { name: string; url?: string }, prefix: string, explicit = false): Promise<void> {
  if (!item.url) return;
  const prefs = (window as unknown as { iwanPrefs?: Record<string, unknown> }).iwanPrefs ?? {};
  if (!explicit && prefs['downloadConfirm'] !== false) {
    const ok = await confirm(t('core.ui.download_confirm', { name: item.name }), { okLabel: t('core.ui.download') });
    if (!ok) return;
  }
  window.open(prefix + item.url + '&dl=1', '_blank');
}
